module.exports = __webpack_public_path__ + "static/img/omn.1995dc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/omn.svg
// module id = rO8p
// module chunks = 0